
import { Watch, BaseTLTableComponent, BaseTLTableBase,  AxiosResponse, TagService, TagFilter } from "../../../Infrastructure/CorBase/CoreBase";


	export default class TagListBase extends BaseTLTableComponent {
		tagService: TagService = new TagService();
		selectItems: any[] = [];	

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let filter: TagFilter = new TagFilter(this.$store.state.idTenant, null);
			return this.tagService.getAllByFilter(filter);
		}

		//zatím nepotrebujeme
		fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return this.fetchDataFromServer();
		}

		refreshItems(items: any[], refreshData: any[]) {
			return items;
		}

		prepareItems(items: any[]) {
			// zde zatim nepotrebujeme
		}

		loadFilters(value: any) { super.loadFilters(value); }
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) {
			super.detailClick(elementId);
		}
		//tooltipColumnBackGround
		setFields() {
			this.fields = [
				/*{ key: 'id', label: 'id', sortable: true, class: 'text-center ' },*/
				{ key: 'name', label: this.$t('tag.fieldName'), trans: 'tag.fieldName', sortable: true, class: 'text-left  ', design: 'tagOne' },
				//{ key: 'color', label: this.$t('tag.fieldColor'), trans: 'tag.fieldColor', sortable: false, class: 'text-left ', design: 'color' },
				//{ key: 'mediaAssigned', label: this.$t('tag.fieldAssigned'), trans: 'tag.fieldAssigned', sortable: false, class: 'text-left', tooltip: 'allScreensName', design: 'link_tooltip_list', minLengthToShowTooltip: 4 },

				{ key: 'screenList', label: this.$t('tag.fieldAssigned'), trans: 'tag.fieldAssigned', sortable: false, class: 'text-left  ', tooltip: 'allScreensName', design: 'allReceiversTag'},
				{ key: 'description', label: this.$t('tag.fieldDescription'), trans: 'tag.fieldDescription', sortable: true, class: 'text-left helpMaxWidth400 ', optional: true, visible: false },
				{ key: 'actions', label: this.$t('tag.fieldActions'), trans: 'tag.fieldActions', class: 'text-right', thClass: 'lastColumnTable' }
			]
		};

		//filtry
		setfilters(value: any) {
			if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else {
				this.filters = [
					{ key: 'name', label: this.$t('tag.filterName'), trans: 'tag.filterName', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage },
					{ key: 'description', label: this.$t('tag.filterDescription'), trans: 'tag.filterDescription', selected: false, value: null, type: 'text' }
				];
			}
		}

		selectRowsBase(items: any) {
			this.selectItems = [];
			for (var i = 0; i < items.length; i++) {
				this.selectItems.push(items[i].id);
			}
		}

		protected deleteListServer(): Promise<AxiosResponse<any>> {
			return this.tagService.deleteList(this.deleteItemsList);
		}


		callActionClick() {
			this.isBusy = true;
			if (this.itemsSelected) {
				// bud mame pole cisel - kliklo se na tlacitko smazat pod tabulkou
				let idList: number[] = this.itemsSelected as number[];
				// nebo mame pouze jedno cislo - kliklo se na ikonu kose na radku
				if (idList.length == undefined || idList.length <= 0) {
					let id: number = this.itemsSelected as number;
					if (id) {
						idList = [id];
					}
				}
				if (idList.length > 0) {
					this.isBusy = true;
					this.deleteItemsList = idList;
					super.deleteList();					
				}
			}
			this.itemsSelected = null;
			(this.$refs.tagsTable as BaseTLTableBase).clearSelected();
		}


		//@ts-ignore
		@Watch('$store.state.currentLanguage')
		changeFieldsAfterChangeLanguageD(value: boolean, oldValue: boolean) {
			this.setfilters(null);
		}

	};
